import React from 'react';

const SectionDivider = ({dividerType}) =>(
    <>
    <div className={dividerType}> </div>
    </>
);

export default SectionDivider;